import {MilestoneIcon} from '@primer/octicons-react'
import {Link, Truncate} from '@primer/react'

import styles from './MilestoneMetadata.module.css'

type MilestoneMetadataProps = {
  title: string
  url: string
}

export const MilestoneMetadata = ({title, url}: MilestoneMetadataProps) => {
  return (
    <>
      <span> · </span>
      <Link href={url} muted aria-label={title} className={styles.milestoneLink}>
        <MilestoneIcon size={16} />
        &nbsp;
        <Truncate title={title} className={styles.milestoneTitleTruncate}>
          {title}
        </Truncate>
      </Link>
    </>
  )
}
